// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--iNp4t","title":"styles-module--title--2yBaQ","item":"styles-module--item--2bwXa","active":"styles-module--active--LthkL"};